import { fmtDate, formatPrice, formatQuantity, formatSignedCurrency } from "@/lib/format";
import { useLanguage } from "@/context/LanguageContext";

const TargetsCell = ({ position }) => (
  <td className="px-4 py-3 text-right font-mono text-xs">
    <span className="text-[#10B981]">{position.take_profit ? formatPrice(position.take_profit) : "—"}</span>
    <span className="text-[#4A5567]"> / </span>
    <span className="text-[#EF4444]">{position.stop_loss ? formatPrice(position.stop_loss) : "—"}</span>
  </td>
);

const PositionRow = ({ position, tab, onClose, tr }) => {
  const pnl = tab === "closed" ? position.realized_pnl : position.pnl;
  return (
    <tr data-testid={`position-row-${position.symbol}`} className="border-t border-[#101724]">
      <td className="px-4 py-3 font-mono text-white">{position.symbol}</td>
      <td className={`px-4 py-3 font-mono text-xs uppercase ${position.side === "buy" ? "text-[#10B981]" : "text-[#EF4444]"}`}>
        {String(position.side || "").toUpperCase()}
      </td>
      <td className="px-4 py-3 text-right font-mono text-[#C7D0DE]">{formatQuantity(position.quantity)}</td>
      <td className="px-4 py-3 text-right font-mono text-[#C7D0DE]">{formatPrice(position.entry_price)}</td>
      <td className="px-4 py-3 text-right font-mono text-[#C7D0DE]">
        {formatPrice(tab === "closed" ? position.close_price : position.current_price)}
      </td>
      {tab === "open" ? <TargetsCell position={position} /> : null}
      <td className={`px-4 py-3 text-right font-mono ${pnl >= 0 ? "text-[#10B981]" : "text-[#EF4444]"}`}>
        {formatSignedCurrency(pnl)}
      </td>
      {tab === "closed" ? (
        <td className="px-4 py-3 font-mono text-xs text-[#8A97AD]">{fmtDate(position.closed_at)}</td>
      ) : null}
      {tab === "open" ? (
        <td className="px-4 py-3 text-right">
          <button onClick={() => onClose(position)} data-testid={`close-position-${position.symbol}`}
                  className="rounded-md border border-[#1D2637] px-3 py-2 text-xs text-[#8A97AD] transition-colors hover:border-[#EF4444]/50 hover:text-[#EF4444]">
            {tr("positions.closeBtn")}
          </button>
        </td>
      ) : null}
    </tr>
  );
};

export const PositionsTable = ({ rows, tab, onClose }) => {
  const { t: tr } = useLanguage();
  return (
    <div className="overflow-x-auto rounded-md border border-[#141A26] max-md:hidden">
      <table className="w-full min-w-[820px] text-left text-sm">
        <thead className="bg-[#0D1420] text-[11px] uppercase tracking-[0.2em] text-[#8A97AD]">
          <tr>
            <th className="px-4 py-3">{tr("positions.asset")}</th>
            <th className="px-4 py-3">{tr("positions.side")}</th>
            <th className="px-4 py-3 text-right">{tr("positions.qty")}</th>
            <th className="px-4 py-3 text-right">{tr("positions.entry")}</th>
            <th className="px-4 py-3 text-right">{tab === "closed" ? tr("positions.close") : tr("positions.current")}</th>
            {tab === "open" ? <th className="px-4 py-3 text-right">TP / SL</th> : null}
            <th className="px-4 py-3 text-right">P/L</th>
            {tab === "closed" ? <th className="px-4 py-3">{tr("positions.closedAt")}</th> : null}
            {tab === "open" ? <th className="px-4 py-3 text-right">{tr("positions.action")}</th> : null}
          </tr>
        </thead>
        <tbody data-testid="positions-table-body">
          {rows.map((p) => (
            <PositionRow key={p.id} position={p} tab={tab} onClose={onClose} tr={tr} />
          ))}
        </tbody>
      </table>
    </div>
  );
};
